import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SalaryQrAdd = () => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_KEY;

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      setPreview(URL.createObjectURL(selected));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage("⚠️ Please select an image first.");
      return;
    }

    setLoading(true);
    setMessage("");
    const userid = localStorage.getItem("userid");
    const formData = new FormData();
    formData.append("qr", file);
    formData.append("userid", userid);

    try {
      const res = await axios.post(`${api}/salary/addqr`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          apikey: apikey,
        },
      });

      setMessage(res.data?.message || "✅ QR added successfully!");
      setFile(null);
      setPreview("");
    } catch (err) {
      if (err.response) {
        setMessage(err.response.data?.message || "❌ Upload failed.");
      } else {
        setMessage("⚠️ Network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.card}>
        {/* Header */}
        <div style={styles.header}>
          <button style={styles.backBtn} onClick={() => navigate(-1)}>
            ⬅ Back
          </button>
          <h2 style={styles.title}>Add Salary QR</h2>
        </div>

        {/* Upload Form */}
        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>
            Choose QR Image
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={styles.input}
            />
          </label>

          {preview && (
            <div style={styles.previewWrapper}>
              <img src={preview} alt="QR Preview" style={styles.previewImage} />
            </div>
          )}

          <button type="submit" style={styles.submitBtn} disabled={loading}>
            {loading ? "Uploading..." : "Upload QR"}
          </button>

          {message && <p style={styles.message}>{message}</p>}
        </form>
      </div>
    </div>
  );
};

// ✨ Stylish CSS-in-JS
const styles = {
  pageWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background:" #dddce1",
    padding: "20px",
  },
  card: {
    width: "100%",
    maxWidth: "420px",
    background: "#ffffff",
    borderRadius: "16px",
    padding: "25px",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  backBtn: {
    backgroundColor: "transparent",
    border: "none",
    color: "#1976d2",
    fontSize: "1rem",
    cursor: "pointer",
    fontWeight: "600",
    transition: "color 0.2s ease",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "700",
    color: "#333",
    margin: 0,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  label: {
    textAlign: "left",
    fontWeight: "600",
    color: "#555",
  },
  input: {
    display: "block",
    width: "100%",
    marginTop: "8px",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "0.95rem",
  },
  previewWrapper: {
    marginTop: "15px",
    border: "1px dashed #90caf9",
    borderRadius: "10px",
    padding: "10px",
    backgroundColor: "#f1faff",
    height:"350px"
  },
  previewImage: {
    width: "100%",
    height:"100%",
    borderRadius: "10px",
    objectFit: "contain",
  },
  submitBtn: {
    background: "linear-gradient(135deg, #2196f3, #1976d2)",
    border: "none",
    padding: "12px",
    borderRadius: "8px",
    color: "white",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background 0.3s ease, transform 0.2s ease",
  },
  message: {
    marginTop: "10px",
    fontSize: "0.95rem",
    color: "#333",
  },
};

export default SalaryQrAdd;
